/**
 * 관리자 폼·대화상자 안 모양 — Input(@repo/ui)이 없는 여러 줄 입력·선택칸과 안내 글에 develop 화면(상품 기본 정보 폼·기획전 모달·
 * 상품 목록 발행 불가 안내)과 같은 클래스를 준다. 대화상자마다 같은 클래스를 써서 화면마다 같은 모양이 되게 한다.
 */
export const formStyles = {
  /** 여러 줄 입력 — 상품 기본 정보 폼의 제작 조건 안내 칸과 같다. */
  textarea:
    'min-h-24 w-full rounded-2xl border border-input bg-background px-4 py-3 text-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
  /** 선택칸 — 기획전 모달의 선택칸과 같다(Input 과 같은 높이 36). */
  select:
    'h-9 w-full rounded-2xl border border-input bg-background px-4 text-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
  /** 라벨 + 입력 한 묶음. */
  field: 'flex flex-col gap-1.5',
  /** 입력 위·아래 안내 글. */
  hint: 'text-sm text-muted-foreground',
  /** 되돌릴 수 없는 처리 등 꼭 읽어야 할 노란 안내 — 상품 목록 발행 불가 안내와 같다. */
  notice: 'rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900',
} as const;
